import { readingList } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function ReadingList() {
  const [lead, ...rest] = readingList;

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            index="04"
            kicker="热读推荐"
            title="关于安全吗、靠谱吗，读者问得最多的几篇"
            desc="把最常被问到的问题整理成可阅读的短篇：安全吗怎么判断、真假辨别怎么做、靠谱吗靠什么证明，读完就能上手核对。"
          />
          <a
            href="#discuss"
            className="inline-flex flex-none cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            <i className="ri-chat-1-line" />
            去读者讨论区
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-[1.05fr_1fr] lg:gap-12">
          <article className="group flex flex-col">
            <div className="h-[260px] w-full overflow-hidden rounded-lg border border-background-200 md:h-[340px]">
              <img
                src="https://readdy.ai/api/search-image?query=stylized%20editorial%20flat%20lay%20of%20magazine%20spreads%20and%20reading%20notes%20on%20a%20warm%20cream%20desk%2C%20crimson%20and%20gold%20accents%2C%20soft%20natural%20light%2C%20clean%20minimal%20composition%2C%20high%20detail%20print%20aesthetic&width=1200&height=800&seq=reading-lead-01&orientation=landscape"
                alt="热读推荐头条文章配图"
                title="黑料地址 安全吗 真假辨别 阅读"
                className="h-full w-full object-top transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="mt-5 flex items-center gap-3">
              <span className="rounded-full bg-primary-100 px-3 py-1 text-[11px] font-semibold text-primary-700">
                {lead.tag}
              </span>
              <span className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-time-line" />
                {lead.read}
              </span>
            </div>
            <h3 className="mt-3 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
              <a href="#verify" className="cursor-pointer transition-colors hover:text-primary-700">
                {lead.title}
              </a>
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{lead.summary}</p>
          </article>

          <ul className="flex flex-col divide-y divide-background-200 border-t border-background-200">
            {rest.map((item) => (
              <li key={item.no} className="group py-6 first:border-t-0">
                <div className="flex items-start gap-4 md:gap-6">
                  <span className="font-heading text-2xl font-black leading-none text-background-400 transition-colors group-hover:text-primary-500 md:text-3xl">
                    {item.no}
                  </span>
                  <div className="flex-1">
                    <div className="flex flex-wrap items-center gap-3">
                      <span className="rounded-full bg-secondary-100 px-3 py-0.5 text-[11px] font-semibold text-secondary-900">
                        {item.tag}
                      </span>
                      <span className="flex items-center gap-1 text-xs text-foreground-500">
                        <i className="ri-time-line" />
                        {item.read}
                      </span>
                    </div>
                    <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                      <a href="#guide" className="cursor-pointer transition-colors hover:text-primary-700">
                        {item.title}
                      </a>
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}